(function () {
    "use strict";

    class ConvxCollectionSlider extends HTMLElement {
        constructor() {
            super();
            this.flickityInstance = null;
            this.windowWidth = window.innerWidth;
        }

        connectedCallback() {
            this.initFlickity();
            window.addEventListener("resize", this.updateFlickity.bind(this));
        }

        disconnectedCallback() {
            window.removeEventListener("resize", this.updateFlickity.bind(this));
            if (this.flickityInstance) {
                this.flickityInstance.destroy();
            }
        }

        getFlickityOptions() {
            return window.innerWidth < 768
                ? {
                    cellAlign: "center",
                    contain: true,
                    groupCells: true,
                    draggable: true,
                    prevNextButtons: true,
                    pageDots: false,
                    freeScroll: false,
                    percentPosition: true,
                    wrapAround: true,
                    imagesLoaded: true,
                    lazyLoad: 2
                }
                : {
                    cellAlign: "center",
                    contain: true,
                    groupCells: false,
                    draggable: true,
                    prevNextButtons: true,
                    pageDots: false,
                    freeScroll: false,
                    percentPosition: true,
                    wrapAround: true,
                    imagesLoaded: true,
                    lazyLoad: 2
                };
        }

        initFlickity() {
            if (this.flickityInstance) {
                this.flickityInstance.destroy();
            }
            this.flickityInstance = new Flickity(this, this.getFlickityOptions());

            const prevBtn = this.querySelector('.flickity-button.flickity-previous');
            const nextBtn = this.querySelector('.flickity-button.flickity-next');

            if (prevBtn) {
                prevBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/2021/9723/files/icons8-chevron-left-64.png?v=1633083470" alt="Previous" style="width:24px;height:24px;" />`;
            }

            if (nextBtn) {
                nextBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/2021/9723/files/icons8-chevron-right-64.png?v=1633083470" alt="Next" style="width:24px;height:24px;" />`;
            }
        }

        updateFlickity() {
            if (window.innerWidth !== this.windowWidth) {
                this.windowWidth = window.innerWidth;
                this.initFlickity();
            }
        }
    }

    function onDOMContentLoaded() {
        customElements.define("convx-page-collection-slider", ConvxCollectionSlider);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
            once: true,
        });
    } else {
        onDOMContentLoaded();
    }
})();
